// Type.js
import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "A private non-operating foundation funding African American Churches",
          "Expanding Black Church outreach — Matthew 25:35–40.",
          "Focus: Human Physiological Needs",
          "Focus: Entrepreneurial Business Preparation",
          "Focus: Career Education and Vocational Preparation",
          "Focus: Life, Financial, and Survival Skills"
        ],
        autoStart: true,
        loop: true,
        delay: 35,
        deleteSpeed: 18,
        pauseFor: 1800
      }}
    />
  );
}

export default Type;
